import { render, staticRenderFns } from "./BookingSummary.vue?vue&type=template&id=186eb880&scoped=true"
import script from "./BookingSummary.vue?vue&type=script&lang=ts"
export * from "./BookingSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186eb880",
  null
  
)

export default component.exports